import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateSeasonMaxDate } from '../../actions/seasonActions';
import { updateSeasonActive } from '../../actions/seasonActions';
import { updateSeasonDisplay } from '../../actions/seasonActions';
import { getAllSeasons } from '../../actions/seasonActions';
import SeasonsList from './SeasonsList';

const mapDispatchToProps = dispatch => {
  return {
    updateSeasonMaxDate: (seasonId, maxDate) => {
        dispatch(updateSeasonMaxDate(seasonId, maxDate));
      },
    updateSeasonActive: (seasonId, active) => {
        dispatch(updateSeasonActive(seasonId, active));
      },
    updateSeasonDisplay: (seasonId, display) => {
        dispatch(updateSeasonDisplay(seasonId, display));
      },
    getAllSeasons: () => {
        dispatch(getAllSeasons());
      }
  };
};

const mapStateToProps = state => ({
  seasons: state.seasons.seasons,
  seasonsList: state.seasons.seasonsList,
  allSeasonsList: state.seasons.allSeasonsList,
  allSeasons: state.seasons.allSeasons,
  userSeason: state.user.userSeason 
});

const SeasonsListContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(SeasonsList));
export default SeasonsListContainer;


// WEBPACK FOOTER //
// ./src/components/lists/SeasonsListContainer.js